import { registerCapability } from '../../platform/capability-registry';
import { BareMetalNodesBlock } from './BareMetalNodesBlock';
import { BARE_METAL_NODES_FIELD_KEY_LIST } from './fieldKeys';
import { resolveBareMetalNodesPaths } from './resolvePaths';
import type { BareMetalNodesBlockOptions } from './types';

registerCapability<BareMetalNodesBlockOptions>({
  key: 'bare-metal-nodes',
  fields: [...BARE_METAL_NODES_FIELD_KEY_LIST],
  component: BareMetalNodesBlock,
  defaultPaths: (prefix) => resolveBareMetalNodesPaths(prefix),
  resolvePaths: (prefix, options) => resolveBareMetalNodesPaths(prefix, options),
});
